import Tooltip from 'antd/lib/tooltip';
import { formatDateWithTimezone } from '@/timeHelpers';
import Typography from 'antd/lib/typography';
import * as React from 'react';
import dayjs, { Dayjs } from 'dayjs';

type TimezoneTooltipProps = {
    triggeredAtLabel: string;
    triggeredByMoment: Dayjs;
    use24HourTimeFormat: boolean;
    effectiveTimezone: string;
    style?: React.CSSProperties;
};
const TimeWithConditionalTz = ({
    triggeredAtLabel,
    triggeredByMoment,
    use24HourTimeFormat,
    effectiveTimezone,
    style,
}: TimezoneTooltipProps) => {
    const localTimezone = dayjs.tz.guess();
    const isLocalTimezone = effectiveTimezone === localTimezone;

    const shortTz = dayjs.tz(triggeredByMoment, effectiveTimezone).format('z');

    const text = isLocalTimezone ? triggeredAtLabel : `${triggeredAtLabel} ${shortTz}`;

    const content = <Typography.Text style={style}>{text}</Typography.Text>;

    if (!isLocalTimezone) {
        return content;
    }

    return (
        <Tooltip
            overlayStyle={{ maxWidth: '500px' }}
            title={formatDateWithTimezone(
                triggeredByMoment,
                'fullWithTimezone',
                effectiveTimezone,
                use24HourTimeFormat,
            )}
        >
            {content}
        </Tooltip>
    );
};

export default TimeWithConditionalTz;
